import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CustomerDetailsView from '../customers/CustomerDetailsView';
import CustomerTable from '../customers/CustomerTable';

const AdminCustomersView = () => (
  <Routes>
    <Route element={<CustomerTable viewType="admin" />} path="/" />
    <Route
      element={<CustomerDetailsView viewType="admin" />}
      path="/:pkEcomCustomer"
    />
    <Route element={<Navigate replace to="/admin/customers" />} path="*" />
  </Routes>
);

export default AdminCustomersView;
